import { DELIVERY } from "./actionsTypes";
import { apiStart, apiError, apiSuccess } from "./apiActions";
import { deliveryService } from "../../services/delivery.service";

export const deliveryActions = {
  getDeliveryList,
  getDeliveryDetails,
  getBillingDetails,
  getListOfReturnItems,
  cancelReturnRequest,
  selectedViewDelivery,
  saveReturnRequestAPI,
  viewReturnOrderAPI,
  viewRetrunOrderForm
}

export function getDeliveryList(orderNumber: any, enquiryNumber: any, make: any, backOrderNumber: any, sapId: any, orgId?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.GET_DELIVERY_LIST_FETCHING));
    const response = await deliveryService.getDeliveryList(orderNumber, enquiryNumber, make, backOrderNumber, sapId, orgId);
    if (response?.error) {
      dispatch(apiError(DELIVERY.GET_DELIVERY_LIST_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.GET_DELIVERY_LIST_SUCCESS, response));
      return response || [];
    }
  };
}

export function getDeliveryDetails(enquiryNumber: any, deliveryNumber: any, make: any, orgId: any, sapId: any, page?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.GET_DELIVERY_DETAILS_FETCHING));
    const response = await deliveryService.getDeliveryDetails(enquiryNumber, deliveryNumber, make, orgId, sapId, page);
    if (response?.error) {
      dispatch(apiError(DELIVERY.GET_DELIVERY_DETAILS_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.GET_DELIVERY_DETAILS_SUCCESS, response));
      return response || [];
    }
  };
}

export function saveReturnRequestAPI(data?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.GET_RETURN_DELIVERY_DETAILS_FETCHING));
    const response = await deliveryService.saveReturnRequestAPI(data);
    if (response.error) {
      dispatch(apiError(DELIVERY.GET_RETURN_DELIVERY_DETAILS_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.GET_RETURN_DELIVERY_DETAILS_SUCCESS, response));
      return response || [];
    }
  };
}

export function viewRetrunOrderForm(data?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.VIEW_RETURN_ORDER_FORM_FETCHING));
    const response = await deliveryService.viewRetrunOrderForm(data);
    if (response.error) {
      dispatch(apiError(DELIVERY.VIEW_RETURN_ORDER_FORM_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.VIEW_RETURN_ORDER_FORM_SUCCESS, response));
      return response || [];
    }
  };
}

export function viewReturnOrderAPI(data?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.VIEW_RETURN_ORDER_FETCHING));
    const response = await deliveryService.viewReturnOrderAPI(data);
    if (response.error) {
      dispatch(apiError(DELIVERY.VIEW_RETURN_ORDER_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.VIEW_RETURN_ORDER_SUCCESS, response));
      return response || [];
    }
  };
}

export function getBillingDetails(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.GET_BILLING_DETAILS_FETCHING));
    const response = await deliveryService.getBillingDetails(data);
    if (response.error) {
      dispatch(apiError(DELIVERY.GET_BILLING_DETAILS_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.GET_BILLING_DETAILS_SUCCESS, response));
      return response || [];
    }
  };
}


export function getListOfReturnItems(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.GET_RETURN_ORDER_FETCHING));
    const response = await deliveryService.getListOfReturnItems(data);
    if (response.error) {
      dispatch(apiError(DELIVERY.GET_RETURN_ORDER__ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.GET_RETURN_ORDER_SUCCESS, response));
      return response || [];
    }
  };
}
export function getListOfDownloadInvoiceAPI(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.GET_DOWNLOAD_INVOICE_FETCHING));
    const response = await deliveryService.getListOfDownloadInvoice(data);
    if (response.error) {
      dispatch(apiError(DELIVERY.GET_DOWNLOAD_INVOICE_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.GET_DOWNLOAD_INVOICE_SUCCESS, response));
      return response || [];
    }
  };
}
export function raiseReturnRequest(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.RAISE_RETURN_REQUEST_FETCHING));
    const response = await deliveryService.raiseReturnRequestAPI(data);
    if (response.error) {
      dispatch(apiError(DELIVERY.RAISE_RETURN_REQUEST_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.RAISE_RETURN_REQUEST_SUCCESS, response));
      return response || [];
    }
  };
}
export function getReturnSalesReasonAPI() {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.GET_RETURN_SALES_REASON_FETCHING));
    const response = await deliveryService.getReturnSalesReasonAPI();
    if (response.error) {
      dispatch(apiError(DELIVERY.GET_RETURN_SALES_REASON_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.GET_RETURN_SALES_REASON_SUCCESS, response));
      return response || [];
    }
  };
}

export function updateReturnStatus(payload: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.UPDATE_RETURN_STATUS_FETCHING));
    const response = await deliveryService.updateReturnStatus(payload);
    if (response.error) {
      dispatch(apiError(DELIVERY.UPDATE_RETURN_STATUS_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.UPDATE_RETURN_STATUS_SUCCESS, response));
      return response || [];
    }
  };
}



export function createExcessReturnRequest(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.CREATE_EXCESS_RETURN_REQUEST_FETCHING));
    const response = await deliveryService.createExcessReturnRequest(data);
    if (response.error) {
      dispatch(apiError(DELIVERY.CREATE_EXCESS_RETURN_REQUEST_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.CREATE_EXCESS_RETURN_REQUEST_SUCCESS, response));
      return response || [];
    }
  };
}
export function cancelReturnRequest(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(DELIVERY.CANCEL_RETURN_REQUEST_FETCHING));
    const response = await deliveryService.cancelReturnRequest(data);
    if (response.error) {
      dispatch(apiError(DELIVERY.CANCEL_RETURN_REQUEST_ERROR, response));
      return response || [];
    } else {
      dispatch(apiSuccess(DELIVERY.CANCEL_RETURN_REQUEST_SUCCESS, response));
      return response || [];
    }
  };
}

export function ViewDelivery(order: any) {
  return async (dispatch: any) => {
    if (order) {
      dispatch(apiSuccess(DELIVERY.VIEW_DEILVERY_SUCCESS, order))
    } else if (!order) {
      dispatch(apiError(DELIVERY.VIEW_DELIVERY_ERROR, {}))
    }
  }
}

export function selectedViewDelivery(order: any) {
  return async (dispatch: any) => {
    if (order) {
      dispatch(apiSuccess(DELIVERY.VIEW_DEILVERY_SELECTED_SUCCESS, order))
    } else if (!order) {
      dispatch(apiError(DELIVERY.VIEW_DELIVERY_SELECTED_ERROR, {}))
    }
  }
}

export function downloadInvoice() {
  return async (dispatch: any) => {

  }
}